<template>
  <TransferListBox :api="postBabeTransferLog" />
</template>
<script>
import { postBabeTransferLog } from '@/api/babe'

import TransferListBox from '../../components/TransferListBox.vue'

export default {
  name: 'BabeTransferList',
  components: { TransferListBox },
  data() {
    return {
      postBabeTransferLog
    }
  },
  watch: {
    // '$i18n.locale'() {
    //   this.init()
    // }
  },
  created() {
    // this.init()
  },
  methods: {
    // loadMore() {
    //   console.log('load')
    //   if (this.queryParams.more) {
    //     this.queryParams.page += 1
    //     this.getList()
    //   }
    // },
    // init() {
    //   this.getList()
    // },
    // getList() {
    //   this.loading = true
    //   let params = {
    //     page: this.queryParams.page,
    //     size: this.queryParams.size
    //   }
    //   postTransferLog(params).then((res) => {
    //     this.loading = false
    //     if (!this.list) {
    //       this.list = []
    //     }
    //     this.list = this.list.concat(res.data.lists.data)
    //     if (res.data.lists.data.length < this.queryParams.size) {
    //       this.queryParams.more = false
    //     }
    //     this.loading = false
    //   })
    // },
    // handleActivity(item) {
    //   if (item.status === 1) {
    //     this.handleRoute('/user/activity', item)
    //   } else {
    //     this.handleRoute('/user/actdetail', item)
    //   }
    // },
    // handleBack() {
    //   this.$router.back()
    // },
    // handleRoute(path, item) {
    //   if (item) {
    //     this.$router.push({ path: path, query: { rec_code: item.rec_code } })
    //   } else {
    //     this.$router.push({ path: path })
    //   }
    // },
    // handleStatus(item) {
    //   if (item.status !== 3) {
    //     this.popupVisible = true
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/babe/transferlist.vue